import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaConceptos', NominasNominaConceptos)

function NominasNominaConceptos($api, $schema) {
  this.get = get

  function get(idEmpresa, idNomina) {
    return $api.get('kendu/nominas/nomina/conceptos', {
        idEmpresa: idEmpresa,
        idNomina: idNomina,
      }, {cache: 'nominas'})
      .then(function (data) {
        return data.map(function (item) {
          return format(item)
        })
      })
  }

  function format(data) {
    return $schema(data, {
      Activo: 'boolean',
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Conceptos.js